import React from "react";

import { Player } from "@lottiefiles/react-lottie-player";
import { FadeIn } from "../Utilities/FadeIn";

import motionBlack from "../../animation/02-motion-black.json";

const AnimatedIcon = () => {
  const fadeInDuration = 1000;

  return (
    <FadeIn delay={0} duration={fadeInDuration}>
      <Player autoplay loop src={motionBlack} />
    </FadeIn>
  );
};

export default AnimatedIcon;
